import { useState, useEffect, useCallback, useRef } from 'react';
import request from '../../../../lib/request';
import HtmlRenderer from '../../../../components/htmlRenderer';

const ContentPopup = ({
  dialogRef,
  closeDialog,
  contentId,
  contentPopupOpen,
}) => {
  const carouselRef = useRef(null);
  const itemRefs = useRef([]);

  const [content, setContent] = useState(null);
  const [currentIndex, setCurrentIndex] = useState(0);

  useEffect(() => {
    if (contentPopupOpen) {
      itemRefs.current = [];
      if (carouselRef.current) {
        carouselRef.current.scrollTo({
          left: 0,
        });
      }
      setCurrentIndex(0);
      getContent(contentId);
    }
  }, [contentPopupOpen]);

  const getContent = useCallback(async (id) => {
    try {
      const { result } = await request.get(`/content/${id}`);
      if (result) {
        setContent(result);
      }
    } catch (err) {
      console.log(err);
    }
  }, []);

  const addToRefs = (el) => {
    if (el && !itemRefs.current.includes(el)) {
      itemRefs.current.push(el);
    }
  };

  const handleScroll = () => {
    itemRefs.current.forEach((item, index) => {
      const rect = item.getBoundingClientRect();
      const containerRect = carouselRef.current.getBoundingClientRect();

      // Check if item is fully or partially visible
      if (
        rect.left >= containerRect.left &&
        rect.right <= containerRect.right
      ) {
        setCurrentIndex(index);
      }
    });
  };

  const handleDownload = () => {
    if (content?.downloadUrl) {
      window.open(content?.downloadUrl, '_blank');
    }
  };

  return (
    <dialog
      ref={dialogRef}
      className='p-4 w-full h-full max-w-lg max-h-full bg-primary scrollbar-hidden text-white'
    >
      <div className='flex items-center justify-between fixed top-0 left-0 right-0 max-w-lg mx-auto px-4 py-2 bg-primary'>
        <h1 className='text-lg font-bold'>{content?.title}</h1>
        <button
          className='text-2xl flex items-center justify-end'
          onClick={closeDialog}
        >
          🅧
        </button>
      </div>

      <div className='flex-1 overflow-y-auto mt-8 scrollbar-hidden'>
        {content?.category === 'CAROUSEL' ? (
          <div
            ref={carouselRef}
            className='relative flex items-center justify-start gap-4 overflow-x-auto scrollbar-hidden snap-mandatory snap-x rounded-xl'
            onScroll={handleScroll}
          >
            {content.contentUrls.map((url, i) => (
              <div
                key={i}
                ref={addToRefs}
                className='relative flex-shrink-0 w-full snap-always snap-center bg-tertiary rounded-xl'
              >
                <div className='w-full h-full overflow-hidden rounded-xl'>
                  <img
                    src={url}
                    alt={content.title}
                    className='w-full h-full object-cover'
                  />
                </div>
              </div>
            ))}
          </div>
        ) : (
          <div className='w-full h-full overflow-hidden rounded-xl'>
            <HtmlRenderer htmlString={content?.content || ''} />
          </div>
        )}
      </div>
      <div className='flex items-center justify-center gap-2 mt-4'>
        {content?.contentUrls?.map((_, i) => (
          <div
            key={i}
            className={`w-[6px] h-[6px] rounded-full ${
              i === currentIndex ? 'bg-accent' : 'bg-white/50'
            }`}
          ></div>
        ))}
      </div>
      {content?.downloadUrl && (
        <div className='mt-4'>
          <button
            className='rounded-full w-full py-2 bg-accent text-black flex justify-center font-bold'
            onClick={handleDownload}
          >
            Download
          </button>
        </div>
      )}
    </dialog>
  );
};

export default ContentPopup;
